import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';
import Icon from 'src/components/HTKit/Icon';
import { pluralize } from 'src/utils/text';
import styles from './styles.scss';

const TechInfo = ({ techInfo, className }) => {
  const info = [
    { icon: 'map-pin', stat: techInfo.location },
    { icon: 'checkmark-broken-circle', stat: 'Vetted & Background Checked' },
  ];
  return (
    <div className={className}>
      {info.map((s) => (
        <>
          <div className="flex paddingBottom-small2">
            <Icon name={s.icon} className={styles.infoIcon} />
            <p className="p1 n800 paddingLeft-tiny1"> {s.stat} </p>
          </div>
        </>
      ))}
    </div>
  );
};

export const TechStats = ({ techInfo, className, onRatingClick}) => {
  const yearsActive = moment().diff(techInfo.startDate, 'years');
  const monthsActive = moment().diff(techInfo.startDate, 'months');
  const pluralText = pluralize('year', yearsActive);
  const timeActive = yearsActive < 1 ? `${monthsActive} months` : `${yearsActive} ${pluralText}`;
  const showActiveStat = monthsActive > 3;
  const stats = [
    { title: 'Jobs Completed', stat: techInfo.jobsCompleted },
    { title: 'Overall Rating', stat: techInfo.rating, icon: 'rating-star', click: true },
    showActiveStat && { title: 'At HelloTech', stat: timeActive },
  ];
  const statsStyles = cn('flex', className, styles.statsWrapper, {
    justifyContentSpaceAround: !showActiveStat,
    justifyContentSpaceBetween: showActiveStat,
  });

  return (
    <div className={statsStyles}>
      {stats.map((s) => {
        const statWrapperStyles = cn('text-align-center', styles.stats, {
          [styles.rating]: s.click,
        });
        return (
        <>
          {s !== null && (
            <div className={statWrapperStyles} onClick={s.click ? () => onRatingClick() : ()=>{}}>
              <h3 className="paddingBottom-tiny1 text-weight-med flex alignItemsCenter justifyContentCenter">
                {s.stat}
                {s.icon && (
                  <Icon name={s.icon} className={cn('paddingLeft-tiny1', styles.statIcon)} />
                )}
              </h3>
              <p className="p2 n700">{s.title}</p>
            </div>
          )}
        </>
      )})}
    </div>
  );
};

TechStats.propTypes = {
  techInfo: PropTypes.object,
  className: PropTypes.string,
  onRatingClick: PropTypes.func,
};

TechInfo.propTypes = {
  techInfo: PropTypes.object,
  className: PropTypes.string,
};

export default TechInfo;
